import Solution from "./solution";
// import compare from "../../Utils/compare";

const testCases = [
  {
    num: 5.0,
  },
  {
    num: 4,
  },
  {
    num: 2.2,
  },
  {
    num: 1.01,
  },
  {
    num: 1.0,
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { num } = test;
      let outcome1 = output()(num);
      let outcome2 = Solution(num);
      const result = outcome1 === outcome2;
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
